import { Component, ViewChild } from '@angular/core';
import { ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';
import { BasePageCRUDComponent } from '@m4u-angular/base/component/BasePageCRUDComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntitiesResponse, BaseState, NotificationServer, NotificationTemplate } from '@m4u-angular/base/entities/BaseEntities';
import { NotificationServerEndpoint } from '@m4u-angular/core/endpoints/notification-server.endpoint';
import { NotificationTemplateEndpoint } from '@m4u-angular/core/endpoints/notification-template.endpoint';
import { EnumMessageBoxTypes, EnumPageDisplayModes} from '@m4u-angular/core/framework/sysenums.enum';
import { HtmlBoxDialogComponent } from '@m4u-angular/ui/dialogs/htmlbox-dialog/htmlbox-dialog.component';
import { MessageBoxDialogComponent } from '@m4u-angular/ui/dialogs/messagebox-dialog/messageboxdialog.component';
import { DxTextAreaComponent, DxTextBoxComponent } from 'devextreme-angular';
import { NotificationPreviewDialogComponent } from '../notification-preview-dialog/notification-preview-dialog.component';

export class State extends BaseState {
    NotificationServers: NotificationServer[] = [];
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-template',
    templateUrl: './notification-template.component.html',
    styleUrls: ['./notification-template.component.scss']
})
export class NotificationTemplateComponent extends BasePageCRUDComponent<NotificationTemplate, State, NotificationTemplateEndpoint> {

    @ViewChild('htmlEditorDialog') htmlEditorDialog: HtmlBoxDialogComponent;
    @ViewChild('previewDialog') previewDialog: NotificationPreviewDialogComponent;
    @ViewChild('messageBox') messageBox: MessageBoxDialogComponent;
    @ViewChild('htmlBody') htmlBody: DxTextAreaComponent;
    @ViewChild('phone') phone: DxTextBoxComponent;

    get SelectedNotificationServer() {
        return this.State.NotificationServers && this.Entity.NotificationServerID && this.Entity.NotificationServerID === -999 ? this.State.NotificationServers.find(n => n.EntryID !== -999) : this.State.NotificationServers.find(n => n.EntryID === this.Entity.NotificationServerID);
    }

    multipleEmailPattern: any = /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))*$/;
    infoUPhonePattern: any = /^[a-zA-Z0-9\s]*$/;

    constructor(
        A: ServiceBagService,
        private endpoint: NotificationTemplateEndpoint,
        private notificationServerEndpoint: NotificationServerEndpoint) {
        super(A, 'NotificationTemplateComponent', NotificationTemplate, State, endpoint, EnumPageDisplayModes.Window);
    }

    protected override OnInitComponent(): void {
        this.LoadNotificationServers();
    }

    protected override OnEntityInitObjectName() {
        return this.Entity && this.Entity.Name;
    }

    protected override OnEntitySaved() {
        this.NavigateBack();
    }

    protected override OnInitContextMenus(): ContextMenuElement[] {
        if (this.IsAddMode) return undefined;

        return [{
            text: this.RC('titleDelete'),
            visible: true,
            onClick: this.OnDelete.bind(this)
        }];
    }

    private LoadNotificationServers() {
        this.Do(this.notificationServerEndpoint.GetList(), false, (response: BaseEntitiesResponse<NotificationServer>) => {
            if (response.Entities.length === 1) {
                const defaultNotificationServer = {
                    EntryID: -999, 
                    SMTPServer: this.RC('lblUseDefault')
                } as any;
                this.State.NotificationServers = [defaultNotificationServer, ...response.Entities];
                if (!this.Entity.NotificationServerID) this.Entity.NotificationServerID = -999;
            } else this.State.NotificationServers = response.Entities;
        });
    }

    OnShowInEditor() {
        this.htmlEditorDialog.Language = this.Entity.Language;
        this.htmlEditorDialog.ShowDialogShort((state: any) => {
            this.Entity.HTMLBody = state.HTMLBody;
        });
    }

    OnShowPreview() {
        this.previewDialog.ShowDialogShort(() => {});
    }

    override OnDelete(): void {
        this.messageBox.Type = EnumMessageBoxTypes.YesNo;
        this.messageBox.Prompt = this.RC('msgDeleteNotificationTemplateQuestion');
        this.messageBox.ShowDialogShort(() => { this.DeleteEntity(); });
    }

    OnEmailSectionToggle(isOpened: boolean) {
        if (isOpened) setTimeout(() => this.htmlBody && this.htmlBody.instance.repaint());
    }

    OnPhoneSectionToggle(isOpened: boolean) {
        if (isOpened) setTimeout(() => this.phone && this.phone.instance.repaint());
    }
}
